import { render, staticRenderFns } from "./MileagePage.vue?vue&type=template&id=65960382&scoped=true"
import script from "./MileagePage.vue?vue&type=script&lang=js"
export * from "./MileagePage.vue?vue&type=script&lang=js"
import style0 from "./MileagePage.vue?vue&type=style&index=0&id=65960382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65960382",
  null
  
)

export default component.exports